<template>
  <Authenticator class="my-2">
    <div class="md my-2">
      <div class="section-block">
        <h1>Badges</h1>
        <p class="section-desc">Provide recognition for achievements and behaviour in your organisation.</p>
        <router-link :to="'/badges/user/'+viewer_email">
          <button type="button" class="btn btn-outline-light w-100">
            View my badges
          </button>
        </router-link>
      </div>
      <div class="section-line"></div>
      <div class="section-block">
        <h2>View badges</h2>
        <form class="mb-2"
              @submit.prevent="view_badges">
          <input class="form-control w-100 mb-2"
                  name="target_email"
                  :placeholder="'...@'+organisation"
                  required />
          <button type="submit"
                  class="btn btn-outline-light">
            View badges
          </button>
        </form>
        <div v-if="view_badge_error"
              class="alert alert-warning mt-2"
              role="alert">
          {{ view_badge_error }}
        </div>
      </div>
      <div class="section-line"></div>
      <div class="section-block">
        <h2>Award a badge</h2>
        <router-link to='/badges/award'>
          <button type="button" class="btn btn-outline-light w-100">
            Award a badge
          </button>
        </router-link>
      </div>
      <div class="section-line" v-if="is_badge_administrator"></div>
      <div class="section-block" v-if="is_badge_administrator">
        <h2>Badge administrators</h2>
        <router-link to='/badge_administrators'>
          <button type="button" class="btn btn-outline-light w-100">
            Manage badge administrators
          </button>
        </router-link>
      </div>
    </div>
  </Authenticator>
</template>

<script>
  import Authenticator from '@/authenticator/authenticator.js'
  import { get_email, get_badge_administrators, post_user } from '@/backend/backend.js'
  import { get_valid_email } from '@/badges/badges.js'

  export default {
    components: {
      Authenticator
    },
    data() {
      return {
        viewer_email: null,
        view_badge_error: null,
        is_badge_administrator: false,
      }
    },
    created() {
       document.title = "Badges"
    },
    mounted() {
      get_email().then(
        email => {
          this.viewer_email = email

          get_badge_administrators().then(
            badge_administrators => {
              if (!badge_administrators) { return }
              this.is_badge_administrator = badge_administrators.includes(email)
            }
          )
        }
      )
      post_user()
    },
    methods: {
      view_badges(submit_event) {
        var data = new FormData(submit_event.target)
        var data_object = {}
        data.forEach((value, key) => {
          data_object[key] = value
        })

        var target_email = get_valid_email(data_object.target_email)
        if (!target_email) {
          this.view_badge_error = "Email is not valid."
          return
        }

        var target_organisation = target_email.split('@')[1]
        if (target_organisation != this.organisation) {
          this.view_badge_error = "You can only view badges from your own organisation (...@" + this.organisation + ")."
          return
        }

        // eslint-disable-next-line
        this.$router.push('/badges/user/'+target_email)
        this.$forceUpdate()
      }
    },
    computed: {
      organisation() {
        if (!this.viewer_email) { return null }
        return this.viewer_email.split('@')[1]
      }
    }
  }
</script>

<style scoped>
  .section-block {
    padding: 20px 24px;
  }
  .section-line {
    height: 1px;
    background: var(--border-default);
  }
  .section-desc {
    color: var(--text-secondary);
    margin-bottom: 16px;
  }
</style>
